import { HeadData } from '@/components/HeadData';
import { type FragmentType, useFragment } from '@/gql/codegen';
import { graphql } from '@/gql/codegen/gql';
import type React from 'react';
import { useCallback, useState } from 'react';
import { CourseLessonMoviePageComponent } from '..';

export const COURSE_LESSON_MOVIE_FRAGMENT = graphql(/* GraphQL */ `
  fragment EmbaCourseLessonMovie on CourseLessonMovie {
    id
    vimeoEmbedUrl
    fileRedirectUrl
  }
`);

export type CourseLessonMovieContainerProps = {
  content: FragmentType<typeof COURSE_LESSON_MOVIE_FRAGMENT>;
  lessonName: string;
  chapterName: string;
  userAttendanceSlug: string;
  onEmbaStartCourseLesson: () => Promise<void>;
  onEmbaCompleteCourseLesson: () => Promise<void>;
  headTitle: string;
};

export const CourseLessonMovieContainer = ({
  content,
  lessonName,
  chapterName,
  onEmbaStartCourseLesson,
  onEmbaCompleteCourseLesson,
  headTitle,
}: CourseLessonMovieContainerProps) => {
  const [isStarted, setIsStarted] = useState(false);

  const embaCourseLessonMovieData = useFragment(
    COURSE_LESSON_MOVIE_FRAGMENT,
    content,
  );

  const onLessonStartEvent = useCallback(async () => {
    if (isStarted) return;

    await onEmbaStartCourseLesson();
    setIsStarted(true);
  }, [isStarted, onEmbaStartCourseLesson]);

  const onLessonCompleteEvent = useCallback(async () => {
    await onEmbaCompleteCourseLesson();
  }, [onEmbaCompleteCourseLesson]);

  const onClickDownload = () => {
    window.open(embaCourseLessonMovieData.fileRedirectUrl, '_blank');
  };

  return (
    <>
      <HeadData title={headTitle} />
      <CourseLessonMoviePageComponent
        lessonName={lessonName}
        chapterName={chapterName}
        vimeoEmbedUrl={embaCourseLessonMovieData.vimeoEmbedUrl}
        onLessonStartEvent={onLessonStartEvent}
        onLessonCompleteEvent={onLessonCompleteEvent}
        onClickDownload={onClickDownload}
      />
    </>
  );
};
